import React, { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./Use_Current_Location.css";
import Your_Location_modal from "../Your_Location_modal/Your_Location_modal";
import Login_Green_Btn from "../../Common-Component/common_btn/login_green_btn/Login_Green_Btn";
import { Context } from "../../../utils/context";
// import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import axios from "axios"; // Axios for API request
import Cookies from "js-cookie";
function Use_Current_Location(props) {
  const { IMG_URL, setCurrentLocation, currentLocation } = useContext(Context);
  const [locationText, setLocationText] = useState("Use Current Location");
  const [isLoading, setIsLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false); // State for the "Type manually" modal
  const [errorLocation, setErrorLocation] = useState("Use Current Location");
  const handleUseCurrentLocation = () => {
    setLocationText("Fetching your location...");
    setIsLoading(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

          try {
            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`,
            );

            const results = response?.data?.results;
            const addressDetails = response.data.results[0];
            if (
              !results ||
              response.data.status !== "OK" ||
              results.length === 0
            ) {
              setErrorLocation("Failed to fetch accurate location data");
            }

            // Select best match
            const bestMatch =
              results.find(
                (r) =>
                  r.types.includes("street_address") ||
                  r.types.includes("premise") ||
                  r.types.includes("sublocality_level_1"),
              ) || results[0];

            const addressComponents = bestMatch.address_components;

            const getComponent = (types) => {
              const match = addressComponents.find((comp) =>
                types.some((type) => comp.types.includes(type)),
              );
              return match?.long_name || "";
            };

            const addressParts = {
              colony: getComponent(["neighborhood", "sublocality_level_2"]),
              area: getComponent(["sublocality_level_1", "sublocality"]),
              city: getComponent(["locality"]),
              state: getComponent(["administrative_area_level_1"]),
              country: getComponent(["country"]),
              pincode: getComponent(["postal_code"]),
            };

            const formattedCustomAddress = [
              addressParts.colony,
              addressParts.area,
              addressParts.city,
              addressParts.state,
              addressParts.country,
              addressParts.pincode,
            ]
              .filter(Boolean)
              .join(", ");

            const fullLocationData = {
              ...addressParts,
              formatted_address: formattedCustomAddress,
              raw: bestMatch,
              coordinates: { lat: latitude, lng: longitude },
              place_id: bestMatch.place_id,
              types: bestMatch.types,
            };

            // Save to cookies
              Cookies.set(
              "current_location_localmandai",
              JSON.stringify(fullLocationData),
            );
            // Cookies.set(
            //   "current_location_localmandai",
            //   JSON.stringify(addressDetails),
            // );
            const location = response.data.results[0];
            // Dispatch to Redux store
            // setCurrentLocation(addressDetails);
             setCurrentLocation(fullLocationData);
            setLocationText("Location fetched");
            setTimeout(() => {
              props.onHide();
            }, 2000);
          } catch (error) {
            console.error("Error fetching location from Google Maps:", error);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
        },
      );
    } else {
      setLocationText("Geolocation is not supported by this browser.");
      setIsLoading(false);
    }
  };

 
  const handleShowLocationModal = () => {
    setShowLocationModal(true); // Show the "Type manually" modal
    props.onHide();
  };

  const handleCloseLocationModal = () => {
    setShowLocationModal(false); // Close the "Type manually" modal
  };

  const handleOpenLocationModal = () => {
    setShowLocationModal(true); // Close the "Type manually" modal
  };

  return (
    <>
      <section className="Use_Current_Location">
        <Modal
          {...props}
          size="md"
          centered
          className="Use_Current_Location modal-holder"
          backdrop="static"
        >
          <Modal.Body>
            <div className="address-text-holder">
              <div className="icon-holder">
                <img
                  className="icon-img"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Image/Icon/green_location.png"
                  }
                  alt="Location Icon"
                />
              </div>
              <div className="text-holder">
                <p>
                  To get quick delivery, we would like to ensure your current
                  location
                </p>
              </div>
            </div>

            <div className="footer-btn-holder">
              {/* <div className="text-center btn_holder">
                <Login_Green_Btn
                  btn_name="Type manually"
                  onClick={handleShowLocationModal}
                />
                
              </div> */}

              <div className="text-center btn_holder">
                <Button
                  className="use-btn "
                  type="button"
                  onClick={handleUseCurrentLocation}
                  disabled={isLoading} // Disable the button while loading
                >
                  {locationText}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Your Location Modal */}
        <Your_Location_modal
          show={showLocationModal}
          onHide={handleCloseLocationModal}
          onOpen={handleOpenLocationModal}
          onBackToChooseLocation={handleCloseLocationModal}
          onOpenYourLocation={handleCloseLocationModal}
          setShowConfimLocModal={props?.setShowConfimLocModal}
        />
      </section>
    </>
  );
}

export default Use_Current_Location;
